import { FILE_TYPES } from '@core/utils/constants/constants'

function getAcceptFilesString(type: 'CV' | 'ATTACHMENTS') {
    const { EXT, MIME } = FILE_TYPES[type]
    // return [...EXT.map((ext) => `.${ext}`), ...MIME].join(',')
    return [...EXT.map((ext) => `.${ext}`), ...MIME]
}

export default getAcceptFilesString
